import {Topic} from './types/topic';

export const getPageObjectIdFromTopic = (topic: Topic) => {
    return parseInt(topic.id, 10);
};
